import styled from "@emotion/styled/macro";
import {breakpoints} from "assets/theme";

const BasePlayerInfo = styled.div`
	height: 26px;
	min-height: 26px;
	max-height: 42px;
	width: 100%;
	background: ${({theme}) => theme.colorPalette.black};
	color: ${({theme}) => theme.colorPalette.white};

	@media (min-width: ${breakpoints.medium}) {
		font-size: 14px;
		height: 42px;
		min-height: 42px;
	}
`;

export const PlayerPosition = styled(BasePlayerInfo)`
	font-size: 16px;
	font-weight: 700;
	line-height: 120%;
	letter-spacing: 0.2px;
	text-transform: uppercase;

	font-family: ${({theme}) => theme.baseFont};
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 0 0 5px 5px;
	transition: all 0.3s;

	@media screen and (max-width: ${breakpoints.mobile}) {
		height: 26px;
		min-height: 26px;
	}
`;

export const PlayerCard = styled.button`
	border: none;
	padding: 0;
	width: 100px;
	height: 100px;
	background: rgba(32, 32, 32, 0.8);
	-webkit-border-radius: 5px;
	-moz-border-radius: 5px;
	border-radius: 5px;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	cursor: pointer;

	@media screen and (max-width: ${breakpoints.mobile}) {
		width: 78px;
		height: 78px;
	}
`;

export const EmptyPlayerCard = styled(PlayerCard)`
	background: rgba(255, 255, 255, 0.5);

	&:hover {
		${PlayerPosition} {
			background: ${({theme}) => theme.colorPalette.white};
			color: ${({theme}) => theme.colorPalette.black};
		}
	}
`;

export const PlayerInfo = styled(BasePlayerInfo)`
	font-family: ${({theme}) => theme.secondFont};
	font-size: 12px;
	font-weight: 500;
	line-height: 120%;
	letter-spacing: 0.26px;
	width: 100%;
	font-family: ${({theme}) => theme.baseFont};
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	border-radius: 0 0 5px 5px;
	transition: all 0.3s;
`;

export const PlayerName = styled.div`
	font-family: ${({theme}) => theme.baseFont};
	font-size: 11px;
	font-weight: 700;
	white-space: nowrap;
	text-overflow: ellipsis;
	overflow: hidden;
	max-width: 90%;
	letter-spacing: 0.2px;

	@media (min-width: ${breakpoints.medium}) {
		font-size: 16px;
	}
`;

export const PlayerTop = styled.div`
	position: relative;
	height: 100%;
	width: 100%;
	display: flex;
	justify-content: center;
	align-items: center;

	.jersey {
		position: absolute;
		left: 0;
		right: 0;
		bottom: -1px;
		height: 140%;
		max-width: 100%;
		width: auto;
		margin: 0 auto;
		-webkit-border-radius: 6px 6px 0 0;
		-moz-border-radius: 6px 6px 0 0;
		border-radius: 6px 6px 0 0;
	}

	button.remove {
		cursor: pointer;
		position: absolute;
		right: 4px;
		top: 0;
		transform: translateY(-50%) rotate(45deg);
		z-index: 5;
	}

	@media screen and (max-width: ${breakpoints.mobile}) {
		.jersey.empty {
			bottom: -5px;
		}
	}
`;

export const PlayerMark = styled.img`
	position: absolute;
	left: 0;
	right: 0;
	bottom: -1px;
	width: 100%;
`;
